import { IReduxAction, actionGenerator } from '../../redux/actionGenerator';

export const SET_BUY_PACKAGE_CONFIRMATION_TOKEN = 'BUY_PACKAGE :: CONFIRMATION_TOKEN';

interface IBuyPackageConfirmationToken {
  confirmationToken: string;
}

export type TSetBuyPackageConfirmationToken = IReduxAction<
  typeof SET_BUY_PACKAGE_CONFIRMATION_TOKEN,
  IBuyPackageConfirmationToken
>;

export const setBuyPackageConfirmationToken = actionGenerator<
  typeof SET_BUY_PACKAGE_CONFIRMATION_TOKEN,
  IBuyPackageConfirmationToken
>(SET_BUY_PACKAGE_CONFIRMATION_TOKEN);
